
<div class="pg-share" :class="star" ref="share">
  <div class="pg-header"></div>
  <!-- <div class="pg-bottom"></div> -->
  <!-- <div :class="star" class="name" v-show="star !== 'boss'"></div> -->
  <div class="logo"></div>
  <div class="slogan" :class="star"></div>
  <div class="scroll-wrapper" :class="star">
    <div class="scroll" :class="star">
      <div>{{nickname}}</div>
    </div>
  </div>
  <div class="friend" :class="star">
    <div class="prize-wrapper" :class="star">
      <Prize
        v-for="(prize, index) in myPrize"
        :key="index"
        :prize="prize.icon"
        :name="prize.title"
      >
      </Prize>
    </div>
  </div>
  <!-- <div class="human"></div> -->
  <div v-if="showHelp" class="help" :class="star" @click="help"></div>
  <div v-else class="draw" :class="star" @click="goHome"></div>
  <a v-if="!ingame" class="btn-download ios" :class="star" @click="iosHandler"></a>
  <a class="btn-download android" :class="star" @click="downloadHandler"></a>
</div>
